import styles from "./EmptyState.module.css";

const Svg = ({ children }) => (
  <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    {children}
  </svg>
);

const icons = {
  orders: (
    <Svg>
      <path d="M22 12h-6l-2 3h-4l-2-3H2" />
      <path d="M5.5 5.1 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.5-6.9A2 2 0 0 0 16.8 4H7.2a2 2 0 0 0-1.7 1.1z" />
    </Svg>
  ),
  products: (
    <Svg>
      <path d="M12.6 2.6A2 2 0 0 0 11.2 2H4a2 2 0 0 0-2 2v7.2a2 2 0 0 0 .6 1.4l8.7 8.7a2.4 2.4 0 0 0 3.4 0l6.6-6.6a2.4 2.4 0 0 0 0-3.4z" />
      <circle cx="7.5" cy="7.5" r="1" />
    </Svg>
  ),
  users: (
    <Svg>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v1" />
    </Svg>
  ),
  payments: (
    <Svg>
      <rect x="2" y="5" width="20" height="14" rx="2" />
      <path d="M2 10h20" />
    </Svg>
  ),
  shipping: (
    <Svg>
      <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" />
      <path d="M15 18H9" />
      <path d="M19 18h2a1 1 0 0 0 1-1v-3.6a1 1 0 0 0-.2-.6l-3.5-4.4a1 1 0 0 0-.8-.4H14" />
      <circle cx="17" cy="18" r="2" />
      <circle cx="7" cy="18" r="2" />
    </Svg>
  ),
  search: (
    <Svg>
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.5-3.5" />
    </Svg>
  ),
};

const iconFor = (content = "") => {
  const c = content.toLowerCase();
  if (/order|dispute|return|batch/.test(c)) return icons.orders;
  if (/product|sourcing|quot/.test(c)) return icons.products;
  if (/user|store|referr|member/.test(c)) return icons.users;
  if (/payment|transaction|deposit|withdraw|refund/.test(c)) return icons.payments;
  if (/shipping|tracking|carrier|mail/.test(c)) return icons.shipping;
  return icons.search;
};

// Admin empty and loading state for tables and tabs.
export default function EmptyState({ loading, content, text }) {
  if (loading) {
    return (
      <div className={styles.empty} role="status" aria-live="polite">
        <span className={styles.spinner} />
        <p className={styles.text}>Loading{content ? ` ${content}` : ""}…</p>
      </div>
    );
  }

  return (
    <div className={styles.empty}>
      <span className={styles.icon}>{iconFor(content)}</span>
      <p className={styles.title}>No {content || "results"} found</p>
      <p className={styles.text}>{text || "Nothing matches this tab or search yet. Try another tab, a different search or a wider date range."}</p>
    </div>
  );
}
